module.exports = __webpack_public_path__ + "static/media/simonx10.e32b9af1.gif";